import React, { Component } from 'react';
import axios from 'axios';

import { Container, Row, Button, Form, FormGroup, Input } from 'reactstrap';

//_Partials
import Header from "../../_partials/Header/Header";
import Sidebar from "../../_partials/Sidebar/Sidebar";

class EditRegistration extends Component {

    constructor(props){
        super(props);
        this.state = {
            formData: {
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                company: ""
            }
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({
          formData
        });
    }
    
    handleSubmit = (e) => {
        e.preventDefault();

        var record = JSON.parse(localStorage.getItem("key"));
        var token = record.token;
        const { formData } = this.state;

        var regID = this.props.match.params.regID;
    
        axios({
            method: 'put',
            url: '/registration/' + regID,
            headers : {
                "x-access-token" : token
            },
            data: {
                firstname: formData.firstname,
                lastname: formData.lastname,
                email: formData.email,
                phone: formData.phone,
                company: formData.company,
                updated_at: new Date().toISOString(), // moment().format('YYYY-MM-DD HH:mm:ss'),
            }
        })
        .then(res => {
          if (res.status === 200) {
            this.setState({
                formData: { firstname: "", lastname: "", email: "", phone: "", company: "" }
            });
            document.getElementById("registration_form").reset();
            window.location.href = '/admin/registrations';
          }
        })
    }

    componentWillMount(){
        var record = JSON.parse(localStorage.getItem("key"));
        var token = record.token;

        var regID = this.props.match.params.regID;

        axios({
            method: 'get',
            url: '/registration/' + regID,
            headers : {
                "x-access-token" : token
            }
        })
        .then(res => {
            if (res.status === 200) {
                var result = res.data;
                this.setState({
                    formData: {
                        firstname: result.firstname,
                        lastname: result.lastname,
                        email: result.email,
                        phone: result.phone,
                        company: result.company
                    }
                });
            }
        })
    }
    
    render() {
        var { formData } = this.state;
        return (
        <div className="AdminAddEvent">
            <Header />
            <Container fluid>
                <Row>
                    <Sidebar />
                    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
                        <h2>Edit Registration</h2>
                        <Form id="registration_form" onSubmit={this.handleSubmit} autoComplete="off">
                            <Row>
                                <FormGroup className="col-6">
                                <Input
                                    type="text"
                                    name="firstname"
                                    onChange={this.handleChange}
                                    id="firstName"
                                    placeholder="First Name"
                                    required="required"
                                    value={formData.firstname}
                                />
                                </FormGroup>
                                <FormGroup className="col-6">
                                <Input
                                    type="text"
                                    name="lastname"
                                    onChange={this.handleChange}
                                    id="lastName"
                                    placeholder="Last Name"
                                    required="required"
                                    value={formData.lastname}
                                />
                                </FormGroup>
                            </Row>
                            <FormGroup>
                                <Input
                                type="email"
                                name="email"
                                onChange={this.handleChange}
                                placeholder="Email"
                                required="required"
                                value={formData.email}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                type="text"
                                name="phone"
                                onChange={this.handleChange}
                                placeholder="Phone Number"
                                required="required"
                                value={formData.phone}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                type="text"
                                name="company"
                                onChange={this.handleChange}
                                placeholder="Company Name"
                                value={formData.company}
                                />
                            </FormGroup>

                            <Button type="submit" className="int-btn blue-btn d-block mx-auto">SUBMIT</Button>
                        </Form>
                    </main>
                </Row>
            </Container>
        </div>
        );
    }
}
export default EditRegistration;